module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    attrs: {
      "withContent": true
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('main', [_c('h1', [_vm._v(_vm._s(_vm.$t("plano.confirmExit.title", {
    name: _vm.name
  })))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("plano.confirmExit.message", {
    name: _vm.name
  })))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.save(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("plano.confirmExit.dontSaveButton")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.cancel();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("plano.confirmExit.cancelButton")))]), _vm._v(" "), _c('button', {
    staticClass: "btn saveButton",
    on: {
      "click": function($event) {
        _vm.save(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.saveButtonText))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d162845","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/modal/ModalExitPlano.vue
// module id = 3133
// module chunks = 0